/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientEmergencyContacts = sqliteTable('patient_emergency_contacts', {
  id: text('id').primaryKey().notNull(),
  patient_id: text('patient_id'),
  relationship_to_patient: text('relationship_to_patient'),
  name: text('name'),
  relationship: text('relationship'),
  phone: text('phone'),
  email: text('email'),
  address: text('address'),
  related_patient_id: text('related_patient_id'),
});
